// extracted by mini-css-extract-plugin
export default {"author":"nPLLcRh5","authorInfo":"C8gzy06d","authorName":"jzAE7Qvc","jobTitle":"uVYVRS5u","link":"_zz32AIm"};